/**
 * @generated SignedSource<<616c17d3cbe85e8dee5f46f82fa45cfe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type customerOrganizations_servicedeskCustomerServiceIssueViewPanel_CustomerOrganization$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "customerOrganizations_servicedeskCustomerServiceIssueViewPanel_CustomerOrganization";
};
export type customerOrganizations_servicedeskCustomerServiceIssueViewPanel_CustomerOrganization$key = {
  readonly " $data"?: customerOrganizations_servicedeskCustomerServiceIssueViewPanel_CustomerOrganization$data;
  readonly " $fragmentSpreads": FragmentRefs<"customerOrganizations_servicedeskCustomerServiceIssueViewPanel_CustomerOrganization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "customerOrganizations_servicedeskCustomerServiceIssueViewPanel_CustomerOrganization",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "CustomerServiceOrganization"
};

(node as any).hash = "5427227533dd119905fd756c684d2c6f";

export default node;
